<template>
      <router-view></router-view>
</template>

<script>
export default {
    name: 'Account',
    components: {
    },
    created() {
    },
    mounted() {
    },
    updated() {
    },
    data(){
        return {
        }
    },
    methods: {
    }
}
</script>